(function() {
    'use strict';

    angular.module('machine')
        .controller('MachineCreateController', MachineCreateController);

    MachineCreateController.$inject = ['$state', '$uibModal', 'machineDataSrvc', 'notificationSrvc', 'machineMessagesConst', 'machineactionPermissionsConst', 'checkModelPermissionsSrvc', 'errorNotificationSrvc'];

    function MachineCreateController($state, $uibModal, machineDataSrvc, notificationSrvc, machineMessagesConst, machineactionPermissionsConst, checkModelPermissionsSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            model: [],
            type: [],
            image: [],
            actions: [],
            nonFieldErrors: []
        };
        self.machineData = {
            name: '',
            model: '',
            type: '',
            image: undefined,
            actions: []
        };

        self.createMachine = createMachine;
        self.cleanErrors = cleanErrors;

        self.actionCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text'
        }, {
            title: 'Podgląd pracy',
            value: 'is_work_preview',
            type: 'boolean'
        }, {
            title: 'Informacje o montażu',
            value: 'is_mounting_info',
            type: 'boolean'
        }, {
            title: 'Weryfikacja kodów użytków',
            value: 'is_use_codes_verification',
            type: 'boolean'
        }, {
            title: 'Drukowanie i weryfikacja kodów użytków',
            value: 'is_use_codes_verification_print',
            type: 'boolean'
        }, {
            title: 'Weryfikacja kodu montażu',
            value: 'is_assembly_codes_verification',
            type: 'boolean'
        }];
        self.modelPermissions = machineactionPermissionsConst;

        self.hasMachineActionViewPermission = hasMachineActionViewPermission;
        self.onActionCreate = onActionCreate;
        self.onActionEdit = onActionEdit;
        self.onActionDelete = onActionDelete;

        function createMachine() {
            return machineDataSrvc.create(
                self.machineData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", machineMessagesConst.add);
                    $state.go('layout.machine.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function hasMachineActionViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                machineactionPermissionsConst.view);
        }

        function onActionCreate() {
            $uibModal.open({
                templateUrl: 'app/machine/views/machine-action-create/machine-action-create.html',
                controller: 'MachineActionCreateController',
                controllerAs: 'ctrl'
            }).result.then(
                function(result) {
                    self.machineData.actions.unshift(result);
                }
            );
        }

        function onActionEdit(row) {
            $uibModal.open({
                templateUrl: 'app/machine/views/machine-action-update/machine-action-update.html',
                controller: 'MachineActionUpdateController',
                controllerAs: 'ctrl',
                resolve: {
                    row: function() {
                        return row;
                    }
                }
            }).result.then(
                function(result) {
                    var index = self.machineData.actions.indexOf(row);
                    self.machineData.actions[index] = result;
                }
            );
        }

        function onActionDelete(row) {
            var index = self.machineData.actions.indexOf(row);
            self.machineData.actions.splice(index, 1);
        }
    }
})();
